
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1iWDT = parcelRequire("1iWDT");

var $6cw5V = parcelRequire("6cw5V");

var $6YMeY = parcelRequire("6YMeY");

var $aGp53 = parcelRequire("aGp53");

var $borQn = parcelRequire("borQn");

var $aPlIY = parcelRequire("aPlIY");

var $jJ0fb = parcelRequire("jJ0fb");
const $67bed3e8c0eeaa97$var$params = new URLSearchParams(document.location.search);
const $67bed3e8c0eeaa97$var$redirect = $67bed3e8c0eeaa97$var$params.get("redirect");
(0, $borQn.effect)(()=>{
    if ((0, $6YMeY.user).value) window.location.href = $67bed3e8c0eeaa97$var$redirect ?? "/delivery";
});
const $67bed3e8c0eeaa97$var$Wrapper = ()=>/*#__PURE__*/ (0, $1iWDT.jsx)("div", {
        class: "theme-blue w-full min-h-full col justify-center items-center",
        children: /*#__PURE__*/ (0, $1iWDT.jsxs)("div", {
            class: "col md:row w-[min(600px,80%)]",
            children: [
                /*#__PURE__*/ (0, $1iWDT.jsx)("div", {
                    class: "col bg-slate-200 md:rounded-l-lg",
                    children: /*#__PURE__*/ (0, $1iWDT.jsx)("a", {
                        href: window.location.origin,
                        title: "VIA",
                        class: "w-20 row aspect-square items-center justify-center m-2 hover:bg-slate-50 rounded-full",
                        children: /*#__PURE__*/ (0, $1iWDT.jsx)((0, $aGp53.Logo), {})
                    })
                }),
                /*#__PURE__*/ (0, $1iWDT.jsx)("div", {
                    class: "bg-white flex-1 md:rounded-r-lg shadow-2xl col p-5 gap-5",
                    children: /*#__PURE__*/ (0, $1iWDT.jsx)((0, $aPlIY.HomeConnect), {
                        user: (0, $6YMeY.user).value ?? null,
                        api: {
                            ...(0, $jJ0fb.accountApi),
                            login: (body)=>(0, $jJ0fb.accountApi).login(body).then(async (e)=>{
                                    window.location.assign("/delivery/new");
                                    return e;
                                }),
                            register: (body)=>(0, $jJ0fb.accountApi).register(body).then(async (e)=>{
                                    await (0, $jJ0fb.accountApi).login({
                                        email: body.email,
                                        password: body.password
                                    });
                                    window.location.assign("/delivery/new");
                                    return e;
                                })
                        },
                        links: {
                            Login: "/login",
                            ChangePassword: "/changePassword",
                            ForgotPassword: "/forgotPassword",
                            ResetPassword: "/resetPassword",
                            Register: "/register",
                            Settings: "/settings",
                            AllCommands: "/delivery",
                            NewCommand: "/delivery/new"
                        }
                    })
                })
            ]
        })
    });
(0, $6cw5V.render)(/*#__PURE__*/ (0, $1iWDT.jsx)($67bed3e8c0eeaa97$var$Wrapper, {}), document.getElementById("root"));


//# sourceMappingURL=index.6f923a25.js.map
